<template>
  <el-container>
    <el-main>
      <el-row type="flex" justify="space-start" :gutter="20">
        <el-col :span="24">
          <el-card
            shadow="always"
            :body-style="{ background: '#f5f5f5' }"
            v-if="customer"
          >
            <div
              slot="header"
              class="clearfix"
            >
              <h2 class="card-title">
                <router-link :to="'/customer/edit/'+customer.id">{{customer.firstname}} {{customer.lastname}}</router-link>
                <small class="pull-right">Customer ID: {{customer.id}}</small>
                
              </h2>
              <i class="ti-email"></i>
              {{customer.email}}
              <i
                v-if="customer.shippingAddress"
                class="fa fa-phone"
              ></i>
              <span v-if="customer.shippingAddress">{{customer.shippingAddress.phone}}</span>
            </div>
            <el-button
              v-show="customer.email"
              v-on:click.prevent="loginAsCustomer"
              type="primary"
            >Login As Customer</el-button>
            <span class="pull-right">Verification status: 
            
            <span
              class="label label-info"
              v-if="customer.verifiedStatus==null"
            >Unverified</span>
            <span
              class="label label-success"
              v-if="customer.verifiedStatus=='verified'"
            >Verified</span>
            <span
              class="label label-danger"
              v-if="customer.verifiedStatus=='requires_input'"
            >Verification Failed</span>

            <el-button
              v-show="customer.verifiedStatus != 'verified'"
              v-on:click.prevent="manuallyVerify"
              type="success"
            >Manually Verify</el-button>

            <el-button
              v-show="customer.verifiedStatus == 'verified' && customer.verificationId"
              v-on:click.prevent="goToVerification"
              type="info"
            >View Verification</el-button>
            
            </span>
          </el-card>
          <el-card
            shadow="always"
            :body-style="{ background: '#f5f5f5' }"
            v-else
          >
            <h2>No customer found with that id</h2>
          </el-card>
        </el-col>
      </el-row>

      <el-row type="flex" justify="space-start" :gutter="20">
        <el-col :span="12">
          <edit-profile-form :customer="customer" :countries="countries"></edit-profile-form>
        </el-col>
        <el-col :span="12">
          <!--<meta-data v-bind:customer="customer"></meta-data>-->
          <customer-order-info v-bind:customer="customer"></customer-order-info>
            <create-cert :customer="customer" v-if="customer"></create-cert>
         <actions :customer="customer" v-if="customer"></actions>
 <lmsprogress :customer="customer" v-if="customer"></lmsprogress>
          <div class="card-footer"></div>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
<script>
import gql from "graphql-tag";
import api from "./api";
import EditProfileForm from "./CustomerProfile/EditProfileForm.vue";
import CustomerOrderInfo from "./CustomerProfile/CustomerOrderInfo.vue";
import Actions from './CustomerProfile/Actions.vue'
import CreateCert from './CustomerProfile/CreateCert.vue'
import Lmsprogress from './CustomerProfile/LMSProgress.vue'
import json from "../../data/allCountries.json";
//import MetaData from './CustomerProfile/MetaData.vue'
//import { CURRENT_CUSTOMER } from '../../store/actions/customer'
export default {
  components: {
    EditProfileForm,
    CustomerOrderInfo,
       Actions,
       CreateCert,
       Lmsprogress
    //   MetaData
  },
  props: ["id"],
  data() {
    return {
      customer: { shippingAddress: { line1: "", line2: "", phone: "" } },
      countries: json,
      session: ""
    };
  },
  methods: {
    loginAsCustomer() {
      const loginAs = api.loginAsCustomer({ username: this.customer.email }); //axios.get(this.usersUrl);
      Promise.resolve(loginAs).then(result => {
        console.log(result)
        this.session = result.data.jwt_token;
        this.userid = result.data.user_id;
        window.open(
          "https://www.tefl.org/my-account/?session=" + this.session + "&userid=" + this.userid
       
        );
      });
    },

    goToVerification() {
        window.open(
          "https://dashboard.stripe.com/identity/verification-sessions/" + this.customer.verificationId
        );
    },

    getCustomer(id) {
      const q = gql`
      query {
        Customer_by_pk (
          id:${id}
        ) {
          id
          title
          email
          username
          firstname
          middlenames
          lastname
          verifiedStatus
          verificationId
          hasPaid
          dateOfBirth
          shippingAddress{    
              id
              line1
              line2
              phone
              town
              postcode
              region
              country
          }
          notes(order_by:{dateCreated:desc}){
            id 
            detail
            createdBy
            dateCreated
            user{
              avatar
            }
          }
        orders(order_by: {dateCreated: desc}){
            id
            status
            boughtProductTotal
            boughtProductTotalDiscounted
            boughtProducts{
              product{
                id
                type
                name
              }
            }
          } 
        }
      }`;
      this.$apollo.query({ query: q }).then(
        resp => {
          console.log("resp", resp);
          this.customer = resp.data.Customer_by_pk;
        },
        error => {
          console.error(
            "Got nothing from server. Prompt user to check internet connection and try again " + error
          );
        }
      );
    },

    deleteCustomer() {
      api.deleteCustomer({ id: this.customer.id }).then(response => {
        //this.notes = response.data.data;
        this.$notify({
          title: "Deleted",
          message: "Customer Deleted",
          type: "success"
        });
        //redirect to create customer
        this.$router.push({ path: "/customers" });
      });
    },

    manuallyVerify() {
    let q = gql`
     mutation updateCustome {
        update_Customer(where: {id: {_eq: ${this.customer.id}}}, _set: {verifiedStatus: "verified"}) {
          returning {
            id
            title
            email
            username
            firstname
            middlenames
            lastname
            verifiedStatus
            verificationId
            hasPaid
            dateOfBirth
            shippingAddress{    
                id
                line1
                line2
                phone
                town
                postcode
                region
                country
            }
            notes(order_by:{dateCreated:desc}){
              id 
              detail
              createdBy
              dateCreated
              user{
                avatar
              }
            }
            orders(order_by: {dateCreated: desc}){
                id
                status
                boughtProductTotal
                boughtProductTotalDiscounted
                boughtProducts{
                  product{
                    id
                    type
                    name
                  }
                }
              }
          }
        }
      }`;
      this.$apollo
        .mutate({
          mutation: q
        })
        .then(result => {
          console.log(result);
          this.customer = result.data.update_Customer.returning[0];
          this.$notify({
            title: "Updated",
            message: "Successfully Verified",
            type: "success"
          });
        });
    },

    getCountries() {
      const registerCountries = api.getCountries(); //axios.get(this.usersUrl);
      Promise.resolve(registerCountries).then(result => {
        this.countries = result.data.data;
      });
    }
  },
  watch: {
    "$route.params.id": function(id) {
      this.getCustomer(id);
    }
  },
  mounted() {
    // this.getCountries();
    this.getCustomer(this.$route.params.id);
  }
};
</script>
<style>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Customers/CustomerDetail.vue